import { createSelector } from '@reduxjs/toolkit';

import { userApi } from './userApi';

export const selectUserAccountData = userApi.endpoints.getAccount.select();
export const selectUserAccount = createSelector(selectUserAccountData, (result) => result?.data);
export const selectUserAccountId = createSelector(selectUserAccountData, (result) => result?.data?.id);
export const selectUserAccountEmail = createSelector(selectUserAccountData, (result) => result?.data?.email);
